export default {
    isHttps(apiName: any) {

        // console.log(this.apiList[apiName])
    },
    apiList: {
        getCarouselImgUrl: {
            url: "testJson/carouselImgUrl.json",
            method: "get"
        },
        getCaseList: {
            url: "https://besttt.ittn.com.cn/api/caselist",
            method: "get"
        },
        getCaseList_NoIntro: {
            url: "https://besttt.ittn.com.cn/api/listcase",
            method: "get"
        },
        getCaseDetail: {
            url: "https://besttt.ittn.com.cn/api/caseview/",
            method: "get"
        }
    }
}